// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Confirmation_titleWrapper__yWzCT","listWrapper":"Confirmation_listWrapper__pRSha"};